export default __webpack_public_path__ + "static/media/comp1.144612e6.svg";